const backgroundColor = { default: 'transparent', small: 'transparent' };
const lineItem = { default: 'default', small: 'small' };
const labeledAmountSubtotal = { default: 'pL', small: 'pS' };
const labeledAmountTotal = { default: 'h6', small: 'p' };

export const fallbackValues = {
  backgroundColor,
  lineItem,
  labeledAmountSubtotal,
  labeledAmountTotal,
};
